<template lang="pug">
.app-footer.w
  .links
    .col.robot
      h3 产品信息
      a(@click="routeGo('/robot3s/info')") 维拉3S
      a(@click="routeGo('/robot3/info')") 维拉3
      a(@click="routeGo('/robot2s/info')") 维拉2S
    .col.service
      h3 售后服务
      a(@click="routeGo('/service#maintenance')") 售后电话
      a(@click="routeGo('/service#maintenance')") 报修方式
    .col.about
      h3 关于我们
      a(@click="routeGo('/about#company-profile')") 公司简介
      a(@click="routeGo('/about#contact-us')") 联系我们
      a(@click="routeGo('/news')") 新闻动态
    .col.cocern
      h3 关注我们
      a.weixin(@click="showWeixinPop")
        span 官方微信
        img.qr-img(src="../assets/web/qr-weixin.png", v-if="!isMobile")
      a.weibo(v-if="isMobile", href="//weibo.com/u/3772228124") 新浪微博
      a.weibo(v-else, href="//weibo.com/u/3772228124", target="_black") 新浪微博
      template(v-if="isMobile")
        a.app(href="http://www.flyingwings.com.cn/download/app/", target="_black")
          span APP下载
      template(v-else)
        a.app
          span APP下载
          img.qr-img(src="../assets/web/qr-app.png")
    .col.tel
      h3 公司总机
      a(href="tel:193 0215 5869") 193 0215 5869
      p 工作日9:00-18:00
  .copyright Copyright &copy 2013-2022 Flyingwings Co.,Ltd. 
    a(href="https://beian.miit.gov.cn/" target="_blank") 沪ICP备12048554号
  transition(name="fade")
    .weixin-pop(v-if="weixinPopShow", @click="weixinPopShow = 0")
      img(src="../assets/web/qr-weixin.png")
</template>

<script>
export default {
  data () {
    return {
      weixinPopShow: false,
    }
  },
  computed: {},
  methods: {
    showWeixinPop () {
      if (this.isMobile) this.weixinPopShow = 1
    },
    routeGo (path) {
      console.log(this.$route.fullPath)
      if (this.$route.fullPath === path) {
        location.reload()
      } else {
        this.$router.push(path)
      }
    }
  },
  created () {},
}
</script>

<style lang="stylus">
@import 'base/base'
.app-footer
  color #7d7d7d
  padding-top 46px
  .links
    overflow hidden
    padding-left 60px
    padding-bottom 50px
    border-bottom 1px solid #ccc
    .col
      float left
      margin-right 130px
      font-size 14px
      &:last-child
        margin-right 0
      h3
        padding-bottom 20px
        font-size 18px
      a
        display block
        height 18px
        line-height 18px
        margin-bottom 5px
        cursor pointer
    .cocern
      padding-right 80px
      margin-right 80px
      position relative
      a
        padding-left 24px
      .weixin
        background url(../assets/web/icon-weixin.png) no-repeat left center
      .weibo
        background url(../assets/web/icon-weibo.png) no-repeat left center
      .app
        background url(../assets/web/icon-app.png) no-repeat left center
      .weixin:hover,
      .app:hover
        .qr-img
          opacity 1
          transform translateX(0)
      .qr-img
        position absolute
        top 40px
        right 0
        width 74px
        height 74px
        transition .5s all
        opacity 0
        transform translateX(20px)
    .tel
      a
        display block
        font-size 22px
        color #27ccc7
        font-weight normal
      p
        padding-top 10px
  .copyright
    text-align center
    padding 35px 0
.is-mobile
  .weixin-pop
    position fixed
    top 0
    right 0
    bottom 0
    left 0
    background rgba(0,0,0,.5)
    display flex
    align-items center
    justify-content center
    img
      width 60%
  .app-footer
    padding-top r(70)
    .links
      // padding-left r(140)
      padding-bottom 0
      border none
      .cocern
        padding 0
      .col
        vertical-align top
        display inline-block
        float inherit
        width r(310)
        margin-right 0
        margin-bottom r(50)
      .tel
        text-align center
        width 100%
        margin-left r(-140 / 2)
        padding-top r(30)
    .copyright
      padding 0 0 r(30)
      font-size r(18)
</style>



// WEBPACK FOOTER //
// src/components/app-footer.vue